import { JournalFeed } from "../../components/journal/JournalFeed";
import { JOURNAL_RESOURCE_TYPES } from "../../components/journal/journal-resource-types";

interface Props {
  teamId: string;
}

/**
 * Surface B — drill-down panel embedded inside the team detail view. Filters
 * the journal feed to the given tournament team and hides the filter bar so
 * the panel stays focused on team activity (the host page is already
 * domain-scoped).
 */
export function TeamJournalDrillDown({ teamId }: Props) {
  return (
    <JournalFeed
      defaultFilters={{
        primaryResourceType: JOURNAL_RESOURCE_TYPES.TEAM,
        primaryResourceId: teamId,
      }}
      title="Activity"
      readOnlyFilters
    />
  );
}
